// @ts-strict-ignore
export const reversedObjectKeyVal = obj => (
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]))
);
